import { GlobalHelperFunctions } from '../../../../utils/GlobalHelperFunctions';
import './style.scss';

export default class ProfileCoursesPanel extends UIObject {
  mDiv: JQuery<HTMLElement>;
  timeCreated: number;
  mData: any;
  requiresBuilding: boolean;
  private _constructorParams: any;

  constructor() {
    super();
  }

  initialize(aConstructorParams: any) {
    this.requiresBuilding = true;

    this._constructorParams = aConstructorParams;
    this.mDiv = this._generateHtml();
  }

  private _generateHtml(): JQuery<HTMLElement> {
    return $(
      HGEN.tree({
        id: 'vnext_learning_panel',
        children: [
          {
            id: 'juno_learning_dashboard',
            style: 'juno_learning_dashboard',
          },
        ],
      }),
    );
  }

  private _navigateToUserProfile(userEmail: string, key: string) {
    //get vnow user id via email address
    App.INSTANCE.mApi.Request(
      CrowdHub_App.CONFIG.BASE_URL + 'crowdhub_api_v2/api_user_getByEmail.php',
      { email: userEmail },
      success => {
        if (!success.user) {
          return;
        }
        const aUrl = App.INSTANCE.appRouter.generate(key, { id: success.user.user_id });
        App.INSTANCE.route(aUrl);
      },
      function (errorResponse) {
        console.error(errorResponse);
      },
    );
  }

  private _buildSettings(): void {
    const { lessonSlug, courseSlug, tabSlug } = this._constructorParams.urlParams || {};
    const firehoseActivity = App.INSTANCE?.firehoseActivity;
    const reportActivity = App.INSTANCE?.reportActivity;
    const routeKey = App.INSTANCE?.mPathObject.as;
    const embeddedScrolling = true;

    /*
     Leon doesn't know what this was for
    window.onpopstate = function (e) {
      // need to manually reload when back button is pressed to the initial state
      if (e.state.idx === 0) {
        location.reload();
      }
    };
    */

    this.timeCreated = Date.now();
    const defaultWidgetProps = App.INSTANCE.defaultVNextWidgetProps();
    this.mData = {
      // todo: pare down this config object to just a theme
      ...defaultWidgetProps,
      pageSlug: 'courses',
      routeKey,
      courseSlug,
      lessonSlug,
      tabSlug,
      embeddedScrolling,
    };

    window.JunoWidgetSettings = window.JunoWidgetSettings || {};
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets || [];
    window.JunoWidgetSettings.widgets.push({
      siteId: CrowdHub_App.CONFIG.VNEXT_SITE_ID,
      widget: 'juno_learning_dashboard',
      mount: 'juno_learning_dashboard',
      data: this.mData,
      timeCreated: this.timeCreated,
    });

    const newScript = document.createElement('script');
    newScript.src = CrowdHub_App.CONFIG.VNEXT_WIDGET_SCRIPT_SRC || `https://widgets.junolive.dev/junoWidgets.js`;
    this.mDiv.append(newScript);
  }

  onTransitionIn(): void {
    if (this.requiresBuilding) {
      this.requiresBuilding = false;
      this._buildSettings();
    }
  }

  destroy(): void {
    const widgetKey = 'juno_learning_dashboard';
    window.JunoWidgetSettings = window.JunoWidgetSettings || {};
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets || [];
    const matchesWidget = widget => widget.widget === widgetKey && widget.timeCreated === this.timeCreated;
    const selectedWidget = window.JunoWidgetSettings.widgets.find(widget => matchesWidget(widget));
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets.filter(widget => !matchesWidget(widget));
    selectedWidget?.reactRoot?.unmount();
  }
}
